import { FC } from 'react';

import { BlogTagInterface } from '@/src/assets/interfaces/blogTagInterface';
import { getUpdateDate } from '@/src/assets/utils/getUpdateDate';

import Wrapper from '../../UI/wrapper/Wrapper';
import { ShareBlock } from '../blogPostShareBlock/BlogPostShareBlock';
import { BlogPostTag } from '../blogPostTag/BlogPostTag';

import styles from './BlogPostFoot.module.scss';

interface BlogPostFootProps {
    postSlug: string;
    postUpdateDate: string;
    postTags?: BlogTagInterface[];
}

const BlogPostFoot: FC<BlogPostFootProps> = ({ postSlug, postUpdateDate, postTags }) => {
    return (
        <Wrapper>
            <div className={styles.postFootWrapper}>
                <div className={styles.postFoot}>
                    <div className={styles.postFootMain}>
                        <span className={styles.postFootUpdateDate}>
                            {getUpdateDate(postUpdateDate)}
                        </span>
                        {postTags && (
                            <div className={styles.postFootTags}>
                                {postTags.map((tag) => {
                                    return <BlogPostTag key={tag._id} tag={tag} />;
                                })}
                            </div>
                        )}
                    </div>
                    <ShareBlock className={styles.postFootShareBlock} postSlug={postSlug} />
                </div>
            </div>
        </Wrapper>
    );
};

export { BlogPostFoot };
